import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store/StoreContext';
import { useRedirectLogin } from 'hooks/UseRedirectLogin';
import { FormErrors, initialFormErrors, getErrorMessage } from 'validators/LoginValidator';
import { useRedirectLoginRequest } from 'hooks/UseRedirectLoginRequest';
import { RoutePath } from 'consts/RoutePath';
import { CircularProgress } from '@material-ui/core';
import { callCheckWhiteListApi } from 'requests/RequestWhiteList';
import { HttpStatus } from 'consts/HttpStatus';
import { convertObjectToGetParameterWithEncode } from 'common/ObjectToGetParameterConverter';
import { unescapeHtml } from 'common/HtmlEscaper';
import { GetLoginDisplayItemResData, callGetLoginDisplayItemApi } from 'requests/RequestLogin';
import { ReactError } from 'consts/ReactError';
import { saveGenerator as loginDisplayItemSaveGenerator } from 'store/connect/LoginDisplayItemData';
import classes from './override.module.scss';

type Props = {};

export type LoginParameters = {
	gakkenId: string;
	password: string;
};

export const RedirectLoginTemplate = memo((_props: Props) => {
	const [store, dispatch] = useStore(); // eslint-disable-line
	const history = useHistory();
	const { redirect_uri, client_id } = useRedirectLoginRequest(dispatch);
	const [formData, setFormData] = useState<LoginParameters>({ gakkenId: '', password: '' });
	const [formErrors, setFormErrors] = useState<FormErrors>(initialFormErrors);
	const isFormError = !!Object.values(formErrors).find((e) => e !== '');
	const [processLoading, setProcessLoading] = useState(false);

	// 各入力欄のonChangeで呼ぶ
	const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};

	const [isPassword, setIsPassword] = useState<boolean>(true);
	const togglePassword = () => {
		setIsPassword((prev) => !prev);
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenIDログイン';
	}, []);

	const errorRef = useRef(null);
	useEffect(() => {
		if (isFormError || store.loginUserData.actionError !== '') {
			errorRef.current.scrollIntoView();
		}
	}, [formErrors, store.loginUserData.actionError]);

	const { login } = useRedirectLogin(formErrors, setFormErrors, getErrorMessage, formData, store, setProcessLoading);

	return (
		<>
			<section className="section">
				<div className="section-in" ref={scrollRef}>
					<div className="section-head">
						<span className={classes.sectionHeadH1}>GakkenIDでログイン</span>
					</div>
					{isFormError || store.loginUserData.actionError !== '' ? (
						<div className="error-box" ref={errorRef}>
							{store.loginUserData.actionError !== '' ? <p>{store.loginUserData.actionError}</p> : null}
							{isFormError ? (
								<>
									<p>※下記項目は全て必須となります。</p>
									<div className="error-box-in">
										{formErrors.gakkenId !== '' ? <p>【GakkenID】{formErrors.gakkenId}</p> : null}
										{formErrors.password !== '' ? <p>【パスワード】{formErrors.password}</p> : null}
									</div>
								</>
							) : null}
						</div>
					) : null}

					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">GakkenID</label>
						</div>
						<div className="form-input">
							<input type="text" name="gakkenId" onChange={handleChangeValue} value={formData.gakkenId} />
						</div>
						<p className="error">{formErrors.gakkenId}</p>
					</div>
					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">パスワード</label>
						</div>
						<div className="form-input">
							<input
								type={isPassword ? 'password' : 'text'}
								name="password"
								onChange={handleChangeValue}
								value={formData.password}
							/>
							<span className={`icon-password ${isPassword ? '' : 'is-active'}`} onClick={togglePassword}></span>
						</div>
						<p className="error">{formErrors.password}</p>
					</div>
					<div className="btn-box">
						<div className="btn gr">
							{processLoading ? <CircularProgress /> : <button onClick={login}>ログイン</button>}
						</div>
					</div>
					<div className="forgot-txt">
						<Link to={RoutePath.FORGOT_ID}>GakkenIDをお忘れの方はこちら</Link>
					</div>
					<div className={classes.passwordForgotTxt}>
						<Link to={RoutePath.FORGOT_PASSWORD}>パスワードをお忘れの方はこちら</Link>
					</div>
				</div>
			</section>
		</>
	);
});
